import React from 'react';
import PropTypes from 'prop-types';
import { AuthProvider } from './auth';
import { ClienteProvider } from './cliente';

function AppProvider({ children }) {
  return <AuthProvider>
    <ClienteProvider>{children}</ClienteProvider>
         </AuthProvider>;
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
